import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import AnimatedIllustrationHomePage from '../pages/AnimatedIllustrationHomePage';
import CreateAnimatedIllustrationPage from '../pages/CreateAnimatedIllustrationPage';
import UpdateAnimatedIllustrationPage from '../pages/UpdateAnimatedIllustrationPage';
// import IconHomePage from '../pages/IconHomePage';
// import UpdateIconPage from '../pages/UpdateIconPage';

function AnimatedAssetsIllustrationsRouter() {
  let { path } = useRouteMatch();
  return (
    <React.Fragment>
      <Switch>
        <Route exact path={`${path}`}>
          <AnimatedIllustrationHomePage />
        </Route>
        <Route exact path={`${path}/${routes.CREATE}`}>
          <CreateAnimatedIllustrationPage />
        </Route>
        <Route exact path={`${path}/:id`}>
          <UpdateAnimatedIllustrationPage />
        </Route>
        <Route path='*'>
          <NotFoundPage />
        </Route>
      </Switch>
    </React.Fragment>
  );
}

export default AnimatedAssetsIllustrationsRouter;
